/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Error_GenericInputs */

const en_claims_error_generic = /** @type {(inputs: Claims_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred. Please try again.`)
};

const fr_claims_error_generic = /** @type {(inputs: Claims_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur s'est produite. Veuillez réessayer.`)
};

/**
* | output |
* | --- |
* | "An error occurred. Please try again." |
*
* @param {Claims_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_error_generic = /** @type {((inputs?: Claims_Error_GenericInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Error_GenericInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_error_generic(inputs)
	return fr_claims_error_generic(inputs)
});